<template>
  <account-print></account-print>
</template>

<script>
import { AccountPrint } from 'zgkaihu'

export default {
  name: 'PrintReceipt',
  components: { AccountPrint }
}
</script>
